import { clampTo, hasImageInput } from '../../tools';
import type { suchuangModelConfig } from '../types';

export const googleConfigs: Record<string, suchuangModelConfig> = {
    'nano-banana-2.1': {
        // https://api.wuyinkeji.com/doc/83
        apiPath: '/api/async/NanoBanana2.1',
        pollApiPath: '/api/async/detail?id=${requestId}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    prompt: prompt,
                    aspectRatio: size === 'match' ? 'auto' : clampTo( aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1', '8:1', '1:8', '4:1', '1:4'] as const, '1:1' ),
                    imageSize: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K' ),
                    // 图片 URL
                    urls: image_urls.slice(0, 14),
                };
            } else {
                return {
                    prompt: prompt,
                    aspectRatio: clampTo( aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1', '8:1', '1:8', '4:1', '1:4'] as const, '1:1' ),
                    imageSize: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K' ),
                };
            }
        },
    },
    'nano-banana-2-lite': {
        // https://api.wuyinkeji.com/doc/74
        apiPath: '/api/async/image_nanoBanana2Lite',
        pollApiPath: '/api/async/detail?id=${requestId}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    prompt: prompt,
                    aspectRatio: size === 'match' ? 'auto' : clampTo(
                        aspectRatio || '16:9',
                        ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const,
                        '16:9',
                    ),
                    // 图片 URL
                    urls: image_urls.slice(0, 10),
                    // system
                    size: '1K',
                };
            }
            return {
                prompt: prompt,
                aspectRatio: clampTo(
                    aspectRatio || '16:9',
                    ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const,
                    '16:9',
                ),
                // system
                size: '1K',
            };
        },
    },
    'nano-banana-2': {
    // https://api.wuyinkeji.com/doc/65
        apiPath: '/api/async/image_nanoBanana2',
        pollApiPath: '/api/async/detail?id=${requestId}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    prompt: prompt,
                    aspectRatio: size === 'match' ? 'auto' : clampTo( aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '1:1' ),
                    size: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K' ),
                    // 图片 URL
                    urls: image_urls.slice(0, 14),
                };
            } else {
                return {
                    prompt: prompt,
                    aspectRatio: size === 'match' ? 'auto' : clampTo( aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '1:1' ),
                    size: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K' ),
                };
            }
        },
    },
    'nano-banana-pro': {
    // https://api.wuyinkeji.com/doc/55
        apiPath: '/api/async/image_nanoBanana_pro',
        pollApiPath: '/api/async/detail?id=${requestId}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    prompt: prompt,
                    aspectRatio: size === 'match' ? 'auto' : clampTo( aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '1:1' ),
                    size: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K' ),
                    // 图片 URL
                    urls: image_urls.slice(0, 14),
                };
            } else {
                return {
                    prompt: prompt,
                    aspectRatio: clampTo( aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '1:1' ),
                    size: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K' ),
                };
            }
        },
    },
    'nano-banana': {
    // https://api.wuyinkeji.com/doc/54
        apiPath: '/api/async/image_nanoBanana',
        pollApiPath: '/api/async/detail?id=${requestId}',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    prompt: prompt,
                    aspectRatio: size === 'match' ? 'auto' : clampTo( aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '1:1' ),
                    // 图片 URL
                    urls: image_urls.slice(0, 14),
                    // system
                    imageSize: '1K',
                };
            } else {
                return {
                    prompt: prompt,
                    aspectRatio: clampTo( aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '1:1' ),
                    // system
                    imageSize: '1K',
                };
            }
        },
    },
};